/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_gc_stat_length = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Length`)
};

const es_gc_stat_length = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Longitud`)
};

const de_gc_stat_length = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Länge`)
};

const nl_gc_stat_length = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lengte`)
};

const fr_gc_stat_length = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Longueur`)
};

const it_gc_stat_length = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lunghezza`)
};

const pt_br2_gc_stat_length = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Comprimento`)
};

const pt_gc_stat_length = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Comprimento`)
};

const ja_gc_stat_length = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`長さ`)
};

const zh_gc_stat_length = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`长度`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const gc_stat_length = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.gc_stat_length(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("gc_stat_length", locale)
	if (locale === "en") return en_gc_stat_length(inputs)
	if (locale === "es") return es_gc_stat_length(inputs)
	if (locale === "de") return de_gc_stat_length(inputs)
	if (locale === "nl") return nl_gc_stat_length(inputs)
	if (locale === "fr") return fr_gc_stat_length(inputs)
	if (locale === "it") return it_gc_stat_length(inputs)
	if (locale === "pt-BR") return pt_br2_gc_stat_length(inputs)
	if (locale === "pt") return pt_gc_stat_length(inputs)
	if (locale === "ja") return ja_gc_stat_length(inputs)
	return zh_gc_stat_length(inputs)
};